import { Component, OnInit, HostListener, Inject, PLATFORM_ID, Pipe, PipeTransform, ViewEncapsulation, viewChild, Input, ChangeDetectorRef, SimpleChanges,Renderer2, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { TranslateDefaultParser, TranslateModule, TranslateService } from '@ngx-translate/core';
import { forEach, each } from 'lodash';
import { JobsidepreviewService } from '../../Services/jobsidepreview.service';
import {
  ReqSidePreviewRequest, ReqSidePreviewResponse, MultipleSiteIdsInfo, RequestQuestionResponse,
  JobFieldsToDisplayInReqSidePreview, JobDetailQuestions, JobDetails, JobFieldsToDisplayInJobDetails,
  PageLoadJDPreviewResponse, exportHeadeinfo
} from 'app/Modules/Job/Models/job-side-preview.model';
import { TgSettingsService } from 'app/services/TG-Setting_Services/tg-settings.service';
import { TranslationInitService } from 'app/services/Translate_Services/translation-init.service';
import * as _ from 'lodash';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { SanitizePipe } from 'app/Modules/Common/pipes/sanitize.pipe';
import { PageHeaderComponent } from 'app/page-header/page-header.component';
import { HtmlencodePipe } from 'app/Modules/Common/pipes/htmlencode.pipe';
import { ShowjobdetailsfieldsbyQIdPipe } from 'app/Modules/Common/pipes/showjobdetailsfieldsby-qid.pipe';
import { GenerateAndDisplayMediaTagsPipe } from 'app/Modules/Common/pipes/generate-and-display-media-tags.pipe';
import { PageFooterComponent } from 'app/Modules/Page-Footer/Components/page-footer.component';
import { SafeHtmlPipe } from 'app/Modules/Common/pipes/safe-html.pipe';
import { ViewChild } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';
import { LCID_TO_LANG } from 'app/services/Translate_Services/lcid-mapping';
import { MutlisiteinfoComponent } from 'app/Modules/Job/Components/multisiteinfo/multisiteinfo.component';
@Component({
  selector: 'app-job-side-preview',
  standalone: true,
  imports: [
    CommonModule, TranslateModule, MatButtonModule,
    HtmlencodePipe, ShowjobdetailsfieldsbyQIdPipe, GenerateAndDisplayMediaTagsPipe, SafeHtmlPipe,
     PageHeaderComponent, PageFooterComponent,MutlisiteinfoComponent
],
  templateUrl: './job-side-preview.component.html',
  styleUrl: './job-side-preview.component.scss',


  providers: [SanitizePipe],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class JobSidePreviewComponent implements OnInit, AfterViewInit {

  // ------------------ State ------------------
  reqsidepreviewrequest!: ReqSidePreviewRequest;
  jobPreviewResponse!: ReqSidePreviewResponse;
  requestQuestionresponses: RequestQuestionResponse[] | null = null;
  JobFieldsToDisplayInReqSidePreview: JobFieldsToDisplayInReqSidePreview | null = null;
  jobDetailQuestions: JobDetailQuestions[] | null = null;
  partnerId!: string;
  siteId!: string;
  JobFieldsToDisplay: JobFieldsToDisplayInJobDetails | null = null;
  footerInfo: any;
  headerInfo: any;
  BrandingConfiguration: any;
  jobDetailFields: JobDetails | null = null;
  multiplesiteidsinfo: MultipleSiteIdsInfo[] = [];
  visibleQuestions: any[] = [];
  tgsettingsdata: any;
  shortMonthNames: string = "";
  selectedSiteId: string = "";
  ActiveSiteId: any;
  NoStieIdSelected: boolean = false;
  LocaleId: any;
  bJobDescriptions = false;
  jdpreviewloading = false;
  bInitialPageLoad = false;
  localeCode: any;
  request:any
  theme: any = { data: { backgroundImage: { selected: 'none' } } }; // Placeholder for missing theme property

  visibleSitesStart: number = 0;
  sitesPageSize: number = 2;
  HeaderBackgorundColor: any;
  private siteCache = new Map<string, any>();
  isDarkMode: boolean = false;
  exportheaderinfo !: exportHeadeinfo
  exportfooterinfo: any;
  siteLocaleId: any;
  DefaultLang: string = 'en-US';
  pageLoadJDPreviewResponse: PageLoadJDPreviewResponse | null = null;
  isJobPreviewMode: boolean = false;
  isJobsidePreviewMode: boolean = false;
  exportRequestSiteInfo : any;
  enableSocialReferral : boolean = false;
  isHotJob : boolean = false;
  ShowSocMediaButtonsOnJobDetailsPage: any;
  isActive :boolean = false;


  @ViewChild(PageHeaderComponent) headerComponent!: PageHeaderComponent;
  @ViewChild('footer', { read: ElementRef }) footerElement!: ElementRef;
  @ViewChild('homeContent', { read: ElementRef }) homeContentElement!: ElementRef;

  constructor(
    private jobSidePreviewService: JobsidepreviewService,
    private translate: TranslateService,
    private cd: ChangeDetectorRef,
    

    @Inject(PLATFORM_ID) private platformId: Object,
    private translationInit: TranslationInitService, private tgSettingsService: TgSettingsService, private sanitizer: DomSanitizer, private renderer: Renderer2
  ) { }

  // ------------------ Lifecycle ------------------
  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);

    if(params.has('PartnerID') && params.has('SiteID')) {
      this.LoadJobPreview()
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId) && this.footerElement && this.homeContentElement) {
      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const height = entry.contentRect.height;
          this.renderer.setStyle(this.homeContentElement.nativeElement, 'padding-bottom', height + 'px');
        }
      });
      resizeObserver.observe(this.footerElement.nativeElement);
    }
  }


  // ------------------ HostListener ------------------
  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent): void {

    if (!isPlatformBrowser(this.platformId)) return;

    if (!event.data?.payload) {
      console.warn('JobSidePreview: No payload in message');
      return;
    }
    // Assign request object
    this.reqsidepreviewrequest = {
      PartnerID: event.data.payload.PartnerID as string,
      SiteIDs: event.data.payload.SiteIDs,
      ReqFormTypeID: event.data.payload.ReqFormTypeID as string,
      requestQuestionresponses: event.data.payload.Responses,
      ActiveSiteId: (event.data.payload.SiteIDs.length >= 1 && event.data.payload.SiteIDs.some((id: any) => id.SiteId == this.ActiveSiteId))
        ? this.ActiveSiteId.toString() : ( event.data.payload.SiteIDs.length == 0 ? null: event.data.payload.SiteIDs[0]?.SiteId.toString()),
      themeMode: event.data.payload.ThemeMode,
      primaryButtonColor: event.data.payload.PrimaryBtnColor,
      BackgroundColor: event.data.payload.BackGroundColor,
      fontColor: event.data.payload.FontColor,
      LocaleId: event.data.payload.LocaleId

    };

    // Trigger service AFTER data arrives 
    if (this.reqsidepreviewrequest.PartnerID == null || this.reqsidepreviewrequest.PartnerID.toString().length == 0 ||  this.reqsidepreviewrequest.SiteIDs == null || this.reqsidepreviewrequest.SiteIDs.length == 0 || this.reqsidepreviewrequest.ReqFormTypeID == null || this.reqsidepreviewrequest.ReqFormTypeID == "") {
      console.warn('Incomplete request data');
      this.jdpreviewloading = false;
      this.NoStieIdSelected = true;
      this.multiplesiteidsinfo = [];
      const lang = LCID_TO_LANG[this.reqsidepreviewrequest.LocaleId] ?? this.DefaultLang;
       if (lang) {
         this.translate.use(lang);
      }
      return;
    }
    else {

      this.NoStieIdSelected = false;
      event.stopPropagation();
      event.preventDefault();
      this.request = this.reqsidepreviewrequest;
      this.multiplesiteidsinfo = this.reqsidepreviewrequest.SiteIDs;
      this.isJobsidePreviewMode = true;
      if (this.siteCache.has(this.reqsidepreviewrequest.ActiveSiteId)) {
        let siteidresponse = this.siteCache.get(this.reqsidepreviewrequest.ActiveSiteId);
        this.setData(siteidresponse);

      }
      else {
        this.loadJobsidePreview(this.reqsidepreviewrequest);
      }
      // }
    }
  }

  // ------------------ API Call ------------------
  private loadJobsidePreview(request: ReqSidePreviewRequest): void {
    this.requestQuestionresponses = this.reqsidepreviewrequest.requestQuestionresponses ?? null;
    this.jdpreviewloading = true;

    this.jobSidePreviewService.getJobSidePreviewData({
      clientId: this.reqsidepreviewrequest.PartnerID, SiteID: this.reqsidepreviewrequest.ActiveSiteId,
      reqFormTypeId: this.reqsidepreviewrequest.ReqFormTypeID
    })
      .subscribe({
        next: async (data) => {
          this.siteCache.set(this.reqsidepreviewrequest.ActiveSiteId, data);
          document.documentElement.style.setProperty('--background-color', this.reqsidepreviewrequest.BackgroundColor);
          document.documentElement.style.setProperty('--primary-btn-color', this.reqsidepreviewrequest.primaryButtonColor);
          document.documentElement.style.setProperty('--font-color', this.reqsidepreviewrequest.fontColor);

          this.isDarkMode = this.reqsidepreviewrequest.themeMode.toLowerCase() == 'darkmode' ? true : false;
          this.headerComponent.switchDarkMode(this.isDarkMode);
          this.multiplesiteidsinfo = this.reqsidepreviewrequest.SiteIDs;
          this.partnerId = this.reqsidepreviewrequest.PartnerID as string;
          
          this.setData(data);


        },
        error: (err) => {
          this.jdpreviewloading = false;
          console.error('Failed to load job side preview:', err);
          this.cd.markForCheck();
        }

      });

  }


  setData(data: PageLoadJDPreviewResponse) {
      //this.jobPreviewResponse = structuredClone(data);
      this.jobDetailQuestions = null;
      const pageData = structuredClone(data);
    this.jobDetailQuestions = structuredClone(pageData?.Jobdetails?.JobDetailQuestions);
    
    this.JobFieldsToDisplay = pageData?.JobFieldsToDisplay;
    this.BrandingConfiguration = pageData?.BrandingConfiguration;
    this.jobDetailFields = pageData?.Jobdetails;
    this.isActive = this.jobDetailFields?.isActive;
    if(this.isJobsidePreviewMode){
    this.isActive = true;
    this.ActiveSiteId = this.reqsidepreviewrequest?.ActiveSiteId;
    }
    this.tgsettingsdata = pageData?.ClientSettings;
    this.bJobDescriptions = !!pageData?.JobFieldsToDisplay?.Summary;
    this.bInitialPageLoad = false;
    this.siteLocaleId = pageData?.ClientSettings?.['DefLocaleId'];
    this.localeCode = pageData?.ClientSettings?.['LocaleCode'];
    this.enableSocialReferral = pageData?.ClientSettings?.['EnableSocialReferral']?.toLowerCase() == "yes" ? true : false;
    this.ShowSocMediaButtonsOnJobDetailsPage = pageData?.ClientSettings?.[ 'ShowSocMediaButtonsOnJobDetailsPage' ]?.toLowerCase() == "yes" ? true : false;  
    if(this.reqsidepreviewrequest?.requestQuestionresponses?.length > 0) {
    this.setResponses();
    }
    this.exportheaderinfo = {
      headerinfo: pageData?.HeaderInfo || [],
      clientsettings: pageData?.ClientSettings || {},
      visualbrandingconfiguration: pageData?.BrandingConfiguration
    };
    this.exportfooterinfo = {
      footerinfo: pageData?.FooterInfo || [],
      clientsettings: pageData?.ClientSettings || {},

    };
    this.isHotJob = _.find(this.jobDetailQuestions, { VerityZone: "hotjob" })?.AnswerValue?.toString().toLowerCase() === "yes";
    const css = document.head || document.getElementsByTagName("head")[0];
    const style = document.createElement("style");
    style.type = "text/css";
    style.id = "compiledCss";
    const rawdata = JSON.parse(unescape(this.BrandingConfiguration));
    _.each(rawdata, (item) => {
      _.each(item, (value, key) => {
        if (key.toLocaleLowerCase().includes("compiledcss")) {
          value = value.replace(/#Q#/g, '"').replace(/#SQ#/g, "'").replace(/#T#/g, '\t').replace(/#N#/g, '\n').replace(/#BS#/g, '\\').replace(/#@#/g, "'").replace(/Helvetica|'Helvetica Neue'/g, "Arial");
          rawdata.compiledCSS = value != "" ? value : "";
        }
        if (key.toLocaleLowerCase().includes("advancedcss")) {
          value = value.replace(/#Q#/g, '"').replace(/#SQ#/g, '"').replace(/#T#/g, '\t').replace(/#N#/g, '\n').replace(/#BS#/g, '\\').replace(/#@#/g, "'").replace(/Helvetica|'Helvetica Neue'/g, "Arial");
          rawdata.advancedCSS = value != "" ? value : "";
        }
      });



    });
    if(rawdata.compiledCSS == undefined || rawdata.compiledCSS == ""){
       rawdata.compiledCSS = ".baseFontColor {  color: #333333;}.baseColorPalette {  background-color: #ffffff;  color: #333333;}.accentBkg {  background-color: #ebebeb;  color: #333333;}.lightAccentBkg {  background-color: #f3f3f3;}.veryLightAccentBkg {  background-color: #f9f9f9;}.darkAccentBkg {  background-color: #cccccc;  color: #333333;}.gateway.themed .accentBkg .borderInAccentBkg {  border-color: #cccccc;}.linkColorOnBkg {  background-color: #ffffff;  color: #00648d;  border-color: #00648d;  outline-color: #00648d;}body,.ui-widget-content a,input {  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;  font-size: 16px;}body,.pageHeader,button,.menu,.dialog .region,.dialog .body,.gateway .baseColorPalette,.ui-widget-content,.facet ul.liner {  background-color: #ffffff;  color: #333333;}.themed .pageHeader {  background-color: #008571;}.themed .headerLink {  color: #336fbb;}.themed.pageFooter {  background-color: #5a5a5a;}.themed.pageFooter .footerLink,.themed.pageFooter .tgLocale {  border-color: #E0E0E0;  color: #ffffff;}.themed.pageFooter a {  color: #ffffff;  border-color: #ffffff;}.themed.pageFooter i {  display: inline-block;  color: #ffffff;  border-color: #ffffff;}svg.styleableColor path,svg.styleableColor rect {  fill: #333333;  stroke: #333333;}a,a:visited,.link,.gateway.themed .linkColor,.jobtitle,.gateway .baseColorPalette a,.gateway .baseColorPalette a:visited,.facetFilterAccordion h3:after {  color: #00648d;}a.sidebarNav,.gateway .sidebarOverlay .sidebar {  background-color: #ffffff;}.backLink {  color: #00648d;}.cue,.prompt,[disabled],::-webkit-input-placeholder,:-moz-placeholder,::-moz-placeholder,:-ms-input-placeholder {  color: #8f8f8f;}.foreground {  color: #ffffff;  background-color: #a6266e;}.foreground span,.foreground a,.foreground a:visited {  color: #ffffff;}.gateway.themed .controlWrapper span,.gateway.themed .controlWrapper a,.gateway.themed .controlWrapper a:visited {  color: #333333;}.themed .hover,.menu a:hover,.ui-menu {  background-color: #f9f9f9;}.ui-state-hover {  outline-color: #333333;}.striped :nth-child(even),.even,.ui-menu-item.ui-state-focus,.ui-datepicker .ui-state-default,.ui-widget-header {  background-color: #008571;  color: #ffffff;}.backgroundColor,.themed .down,.menu a:active,.menu a.active,.applyFlow .layoutsection .heading:before,.themed .ngdialog.ngdialog-theme-default .ngdialog-content {  background-color: #ffffff;}.highlighted > a,.gateway.themed .selectedTile {  background-color: #ebebeb;  color: #333333;}.themed .primaryButton {  background-color: #008571;  color: #ffffff;}.themed .primaryButton:hover {  background-color: #005548;  color: #ffffff;}.themed .primaryButton:active {  background-color: #008571;  color: #ffffff;}.themed .primaryButton .ladda-label,.themed .primaryButton .button-label {  outline-color: #ffffff;}.themed button,a.button {  background-color: #363636;  color: #ffffff;}.themed button:hover,a.button:hover {  background-color: #404040;  color: #ffffff;}.themed button:active,a.button:active {  background-color: #4d4d4d;  color: #ffffff;}.themed button .ladda-label,a.button .ladda-label,.themed button .button-label,a.button .button-label {  outline-color: #ffffff;}.themed .closeButton,.themed .close {  color: #333333;}.themed .closeButton:hover,.themed .close:hover {  background: #d6d6d6;}.themed .closeButton:active,.themed .close:active {  background: #ebebeb;}.themed .clearButton {  color: #333333;}.themed .progressBarContainer .progressBar .meter {  background-color: #a6266e;}.pseudoradio.checked:after {  background-color: #333333;}"
    }
    style.appendChild(document.createTextNode(rawdata.compiledCSS + '\n' + rawdata.advancedCSS));
    document.getElementById("compiledCss")?.remove();
    css.appendChild(style);
     const lang = LCID_TO_LANG[this.siteLocaleId] ?? this.DefaultLang;

    this.jdpreviewloading = false;
    try{
    if (lang) {
      
    this.translate.use(lang);
    }
  }
  catch{
    //this.translate.use(this.DefaultLang);
    console.log("translation not loaded");
  }
    

  }


  setResponses() {
    this.reqsidepreviewrequest;
    this.jobDetailQuestions;
    forEach(this.jobDetailQuestions, (question) => {
      forEach(this.reqsidepreviewrequest.requestQuestionresponses, (reqResponse) => {
        if (question.QuestionId === reqResponse.questionId.toLocaleLowerCase()) {
          question.AnswerValue = "";
          question.AnswerValue = reqResponse.response.toString();

        }

      });
    });

  }

  switchsite(selectedSiteId: string) {

    if (this.siteCache.has(selectedSiteId.toString())) {
      let siteidresponse = this.siteCache.get(selectedSiteId.toString());

      if (siteidresponse != undefined && siteidresponse != null) {
        this.setData(siteidresponse);
      }
      else {

        this.ActiveSiteId = parseInt(selectedSiteId);
        this.reqsidepreviewrequest.ActiveSiteId = this.ActiveSiteId.toString();
        this.reqsidepreviewrequest.PartnerID = this.partnerId;
        this.reqsidepreviewrequest.ReqFormTypeID = this.reqsidepreviewrequest.ReqFormTypeID;
        this.loadJobsidePreview(this.reqsidepreviewrequest);
      }

    }
    else {

      this.ActiveSiteId = parseInt(selectedSiteId);
      this.reqsidepreviewrequest.ActiveSiteId = this.ActiveSiteId.toString();
      this.reqsidepreviewrequest.PartnerID = this.partnerId;
      this.reqsidepreviewrequest.ReqFormTypeID = this.reqsidepreviewrequest.ReqFormTypeID;
      this.loadJobsidePreview(this.reqsidepreviewrequest);
    }


  }


  
  private LoadJobPreview(): void {
    const params = new URLSearchParams(window.location.search);

    this.jobSidePreviewService.getjobpreview({ urlstring: params.toString() }).subscribe({
    next: (data) => {
      this.isJobPreviewMode = true;
        this.setData(data);
        const ele = document.querySelector('.job-side-preview-container') as HTMLElement;
        this.renderer.setStyle(ele, "margin-top", "0px");
       const title = document.getElementsByTagName('title')[0];
       title.innerHTML = "Job Posting Preview";
        this.cd.markForCheck();
    },
    error: (err) => {
      console.error('Failed to load job preview data:', err);
      this.cd.markForCheck();
    }
  });
  }

  WinClose() {
    window.close();
  }
 

}




